import { MenuContainer } from '@zendeskgarden/react-menus';
import { Map } from 'immutable';
import PropTypes from 'prop-types';
// import Tooltip from 'rc-tooltip';
import React from 'react';
// import { Link } from 'react-router';
import { push } from 'react-router-redux';
import styled from 'styled-components';
import { AuthActions } from '../../../actions/auth';
import Avatar from '../../Avatar';
// import LoggedOutUserButton from './LoggedOutUserButton';
import './UserDropdownButton.css';

const CustomMenuContainer = styled.div`
  z-index: 1071;
  position: relative;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 1rem;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  marginleft: 0px;
  :focus {
    outline: none;
  }
`;

const CustomMenuItem = styled.div`
  /* padding: 8px 4px; */
  background-color: ${({ focused }) => (focused ? 'grey' : 'initial')};
  cursor: pointer;
  :hover {
    color: #16181b;
    text-decoration: none;
    background-color: #f8f9fa;
  }
  display: block;
  width: 100%;
  padding: 0.25rem 0.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
`;

class UserDropdownButton extends React.Component {
  static propTypes = {
    user: PropTypes.instanceOf(Map),
    dispatch: PropTypes.func,
  };

  initialState = {
    selectedKey: 'Unknown',
  };

  state = {
    isOpen: false,
  };

  handleLogout = e => {
    const { dispatch } = this.props;

    e.preventDefault();

    dispatch(AuthActions.logout()).then(() => {
      dispatch(push('/login'));
    });
  };

  handleStateChange = state => {
    // const { enableTooltip, disableTooltip } = this.props;
    // state.isOpen ? disableTooltip() : enableTooltip();
    this.setState({
      isOpen: state.isOpen,
    });
  };

  render() {
    const { user, dispatch } = this.props;
    // const adminLink =
    //   user.get('role_id') === 1 ? (
    //     <Link
    //       className="dropdown-item"
    //       to="/admin/organizations"
    //       data-test="adminMenuItem"
    //     >
    //       <i className="fa fa-lock" /> Admin
    //     </Link>
    //   ) : null;

    return (
      <MenuContainer
        theme="main"
        zIndex={1071}
        placement="end-bottom"
        isOpen={this.state.isOpen}
        onStateChange={this.handleStateChange}
        onChange={selectedKey => {}}
        trigger={({ getTriggerProps, triggerRef, isOpen }) => {
          const triggerProps = getTriggerProps({ ref: triggerRef });
          return (
            <div style={{ cursor: 'pointer' }} {...triggerProps}>
              <Avatar user={user} width="37" height="37" softCorners />
            </div>
          );
        }}
      >
        {({ getMenuProps, menuRef, placement, getItemProps, focusedKey }) => (
          <CustomMenuContainer
            theme="main"
            {...getMenuProps({
              innerRef: menuRef,
              // onStateChange: this.handleStateChange,
            })}
          >
            {[
              {
                id: 'admin',
                url: '/admin/organizations',
                display: 'Admin',
              },
              {
                id: 'myProfile',
                url: '/user/profile',
                display: 'My Profile',
              },
              {
                id: 'logout',
                url: '/logout',
                display: 'Logout',
              },
              // {
              //   id: 'help',
              //   url: '/help',
              //   display: 'Help',
              // },
            ].filter((i) => {
              if (i.id === 'admin') {
                const userRole = user.get('role_id');
                return (userRole === 1);
              }
              return i;
            })
            .reduce((prev, item) => {
              return [
                ...prev,
                <CustomMenuItem
                  {...getItemProps({
                    key: item.id,
                    textValue: item.id,
                    // focused: focusedKey === item.id,
                  })}
                  onClick={e => {
                    switch (item.id) {
                      case 'logout':
                        this.handleLogout(e);
                        break;
                      case 'help':
                        break;
                      default:
                        dispatch(push(item.url));
                        break;
                    }
                  }}
                  data-test={item.id}
                >
                  {item.id !== 'help' && (
                    <div
                      style={{
                        display: 'block',
                        width: 'auto',
                        color: '#5e97be',
                      }}
                    >
                      {item.display}
                    </div>
                  )}
                  {item.id === 'help' && (
                    <a
                      href="https://lattixsight.com/help/"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        display: 'block',
                        width: 'auto',
                        color: '#5e97be',
                      }}
                    >
                      {item.display}
                    </a>
                  )}
                </CustomMenuItem>,
              ];
            }, [])}
          </CustomMenuContainer>
        )}
      </MenuContainer>
    );
  }
}

// class _UserDropdownButton extends Component {
//   static propTypes = {
//     user: PropTypes.instanceOf(Map),
//     dispatch: PropTypes.func,
//   };

//   handleLogout = e => {
//     const { dispatch } = this.props;

//     e.preventDefault();

//     dispatch(AuthActions.logout()).then(() => {
//       dispatch(push('/login'));
//     });
//   };

//   render() {
//     const { user } = this.props;
//     const adminLink =
//       user.get('role_id') === 1 ? (
//         <Link
//           className="dropdown-item"
//           to="/admin/organizations"
//           data-test="adminMenuItem"
//         >
//           <i className="fa fa-lock" /> Admin
//         </Link>
//       ) : null;

//     return (
//       <div>
//         {user && (
//           <Tooltip
//             // overlayStyle={{ background: 'white', color: 'red' }}
//             overlayClassName={'moose'}
//             placement="right"
//             trigger={['click']}
//             overlay={
//               <div>
//                 {adminLink}
//                 <Link
//                   className="dropdown-item"
//                   to="/user/profile"
//                   data-test="profileMenuItem"
//                 >
//                   <i className="fa fa-user" /> My Profile
//                 </Link>
//                 <a
//                   className="dropdown-item"
//                   href="http://community.sightplanner.com/content/user-guide-0"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <i className="fa fa-question-circle" /> Help
//                 </a>
//                 <a
//                   className="dropdown-item"
//                   onClick={this.handleLogout}
//                   href="/logout"
//                 >
//                   <i className="fa fa-sign-out" /> Logout
//                 </a>
//               </div>
//             }
//           >
//             <div style={{ cursor: 'pointer' }}>
//               <Avatar user={user} width="37" height="37" softCorners />
//             </div>
//           </Tooltip>
//         )}
//         {!user && <LoggedOutUserButton />}
//       </div>
//     );
//   }
// }

// class UserDropdownButton extends Component {
//   static propTypes = {
//     user: PropTypes.instanceOf(Map),
//     dispatch: PropTypes.func,
//   };

//   handleLogout = e => {
//     const { dispatch } = this.props;

//     e.preventDefault();

//     dispatch(AuthActions.logout()).then(() => {
//       dispatch(push('/login'));
//     });
//   };

//   render() {
//     const { user } = this.props;
//     const adminLink =
//       user.get('role_id') === 1 ? (
//         <Link
//           className="dropdown-item"
//           to="/admin/organizations"
//           data-test="adminMenuItem"
//         >
//           <i className="fa fa-lock" /> Admin
//         </Link>
//       ) : null;

//     return (
//       <div>
//         {user && (
//           <Tooltip
//             // overlayStyle={{ background: 'white', color: 'red' }}
//             overlayClassName={'moose'}
//             placement="right"
//             trigger={['click']}
//             overlay={
//               <div>
//                 {adminLink}
//                 <Link
//                   className="dropdown-item"
//                   to="/user/profile"
//                   data-test="profileMenuItem"
//                 >
//                   <i className="fa fa-user" /> My Profile
//                 </Link>
//                 <a
//                   className="dropdown-item"
//                   href="http://community.sightplanner.com/content/user-guide-0"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <i className="fa fa-question-circle" /> Help
//                 </a>
//                 <a
//                   className="dropdown-item"
//                   onClick={this.handleLogout}
//                   href="/logout"
//                 >
//                   <i className="fa fa-sign-out" /> Logout
//                 </a>
//               </div>
//             }
//           >
//             <div style={{ cursor: 'pointer' }}>
//               <Avatar user={user} width="37" height="37" softCorners />
//             </div>
//           </Tooltip>
//         )}
//         {!user && <LoggedOutUserButton />}
//       </div>
//     );
//   }
// }

export default UserDropdownButton;



// WEBPACK FOOTER //
// ./src/components/buttons/UserDropdownButton/UserDropdownButton2.js